import { request } from '../lib/request';

const exportApi = request({
    baseURL: process.env.REACT_APP_BASE_API + 'csv/exportCSV'
});
  
export const getFileBlobData = async(payload) => {
    return await exportApi.post('',payload);
}
